import { _ as __rest } from './tslib.es6-292fd623.js';
import React__default from 'react';
import './index-b7fc5c49.js';
import '@mantine/core';
import '@mantine/dates';
import './index-d51d2ed9.js';
import './index-41167387.js';
import './index-d4fd2f0b.js';
import './index-8d38edb6.js';
import { T as Text$1 } from './index-62589d09.js';
import './index-fc122c7c.js';
import './index.styles-de54e20e.js';
import './translationsContext-111a9aaa.js';
import '@mantine/hooks';
import './text-af71ddba.js';
import './utils-9de7fd8e.js';
import './index-3e566f55.js';

/**
 * @deprecated Consider to use import { Text } from '@hhgtech/hhg-components/mantine'
 */
const Text = (_a) => {
    var { size = 'base', type = 'regular' } = _a, rest = __rest(_a, ["size", "type"]);
    return (React__default.createElement(Text$1, Object.assign({ size: size, weight: type === 'caption' ? 'bold' : type, "data-size": size, "data-type": type, "data-word-wrap": rest.wordWrap, "data-is-uppercase": rest.isUppercase }, rest)));
};

export { Text as T };
